import axios from 'axios';

const RESOURCE_NAME = '/api/material';

export default {
    getAll() {
        return axios.get(RESOURCE_NAME);
	},
	
	search(query) {
        return axios.get(`${RESOURCE_NAME}?q=${query}`);
	},

    get(id) {
        return axios.get(`${RESOURCE_NAME}/${id}`);
    },

    getSubMaterial() {
        return axios.get('/api/submaterial');
    },


    create(data) {
        return axios.post(RESOURCE_NAME, data);
    },

	createSubMaterial(id, data) {
        return axios.post(`${RESOURCE_NAME}/${id}/submaterial`, data);
    },


    update(id, data) {
        return axios.put(`${RESOURCE_NAME}/${id}`, data);
    },

    delete(id) {
        return axios.delete(`${RESOURCE_NAME}/${id}`);
    }
};


// WEBPACK FOOTER //
// ./src/api-services/material.service.js